/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Chat_ViewInputs */

const en_group_chat_view = /** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation View`)
};

const id_group_chat_view = /** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilan Percakapan`)
};

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const es_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const fr_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const de_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const ja_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const zh_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const ar_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const it_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const ru_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const pt_group_chat_view = en_group_chat_view;

/** @type {(inputs: Group_Chat_ViewInputs) => LocalizedString} */
const ko_group_chat_view = en_group_chat_view;

/**
* | output |
* | --- |
* | "Conversation View" |
*
* @param {Group_Chat_ViewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const group_chat_view = /** @type {((inputs?: Group_Chat_ViewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Chat_ViewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_group_chat_view(inputs)
	if (locale === "es") return es_group_chat_view(inputs)
	if (locale === "fr") return fr_group_chat_view(inputs)
	if (locale === "de") return de_group_chat_view(inputs)
	if (locale === "ja") return ja_group_chat_view(inputs)
	if (locale === "zh") return zh_group_chat_view(inputs)
	if (locale === "ar") return ar_group_chat_view(inputs)
	if (locale === "id") return id_group_chat_view(inputs)
	if (locale === "it") return it_group_chat_view(inputs)
	if (locale === "ru") return ru_group_chat_view(inputs)
	if (locale === "pt") return pt_group_chat_view(inputs)
	return ko_group_chat_view(inputs)
});